import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {HttpService} from '@/services/api';
import {DeleteFile, FilesInitState, FileType, ReferenceID, ResponseFiles} from '@/store/files/files.types';
import {FilesEnumApi} from '@/store/files/files.enum';

export const FilesAction: ActionTree<FilesInitState, RootState> = {
  async _getFiles(req: ActionContext<FilesInitState, RootState>, params: ReferenceID): Promise<any> {
    try {
      let {commit} = req;
      let privatePath = params.private ? 'private' : 'public';
      let fileType = params.fileType === FileType.original ? FileType.original : FileType.thumbnail;
      let tmp = await HttpService.get(`${FilesEnumApi.asset}${privatePath}/${params.refId}/${fileType}`, {}, process.env.VUE_APP_API_FILES) as { data: ResponseFiles };
      commit('mutationGetFiles', tmp.data.data);
      return tmp.data.data;
    } catch (e) {
      console.error('DEBUG: _getFiles ', e.message);
    }
  },
  async _delFile(req: ActionContext<FilesInitState, RootState>, params: string): Promise<void> {
    try {
      let tmp = await HttpService.delete(FilesEnumApi.asset, `${params}`, process.env.VUE_APP_API_FILES);
      return tmp
    } catch (e) {
      console.error('DEBUG: _delFile ', e.message);
    }
  },
  async _getFilesPrimary(req: ActionContext<FilesInitState, RootState>, params: string): Promise<void> {
    try {
      let tmp = await HttpService.get(`${FilesEnumApi.asset}public/primary/${params}`, {}, process.env.VUE_APP_API_FILES);
      return tmp.data.data[0]
    } catch (e) {
      console.error('DEBUG: _getFilesPrimary ', e.message);
    }
  },

  async _getCheckFile(req: ActionContext<FilesInitState, RootState>, params: string): Promise<void> {
    try {
      let tmp = await HttpService.get(`${FilesEnumApi.asset}register/check/${params}`, {}, process.env.VUE_APP_API_FILES);
      return tmp.data.data
    } catch (e) {
      console.error('DEBUG: _getFilesPrimary ', e.message);
    }
  },

  async _getProfile(req: ActionContext<FilesInitState, RootState>, params: ReferenceID): Promise<void> {
    try {
      let {commit} = req;
      let privatePath = params.private ? 'private' : 'public';
      let fileType = params.fileType === FileType.original ? FileType.original : FileType.thumbnail;
      let tmp = await HttpService.get(`${FilesEnumApi.asset}${privatePath}/${params.refId}/${fileType}`, {}, process.env.VUE_APP_API_FILES) as { data: ResponseFiles };
      commit('mutationGetProfile', tmp.data.data);
    } catch (e) {
      console.error('DEBUG: _getFiles ', e.message);
    }
  },
};
